export const visaList = [{
  value: '10',
  text: '10 - Bridging Visa A'
}, {
  value: '20',
  text: '20 - Bridging Visa B'
}, {
  value: '30',
  text: '30 - Bridging Visa C'
}, {
  value: '40',
  text: '40 - Bridging Visa D (Prospective Applicant)'
}, {
  value: '50',
  text: '50 - Bridging General'
}, {
  value: '160',
  text: '160 - Business Owner (Provisional)'
}, {
  value: '161',
  text: '161 - Senior Executive (Provisional)'
}, {
  value: '162',
  text: '162 - Investor (Provisional)'
}, {
  value: '163',
  text: '163 - State/Territory Sponsored Business Owner (Provisional)'
}, {
  value: '164',
  text: '164 - State/Territory Sponsored Senior Executive (Provisional)'
}, {
  value: '165',
  text: '165 - State/Territory Sponsored Investor (Provisional)'
}, {
  value: '173',
  text: '173 - Contributory Parent (Temporary)'
}, {
  value: '176',
  text: '176 - Skilled Sponsored Migration Scheme'
}, {
  value: '186',
  text: '186 - Employer Nomination Scheme'
}, {
  value: '187',
  text: '187 - Regional Sponsored Migration Scheme'
}, {
  value: '188',
  text: '188 - Business Innovation and Investment (Provisional)'
}, {
  value: '300',
  text: '300 - Prospective Marriage'
}, {
  value: '303',
  text: '303 - Emergency (Temporary Visa Applicant)'
}, {
  value: '309',
  text: '309 - Partner temporary visa'
}, {
  value: '400',
  text: '400 - Temporary Work (Short Stay Activity) Visa'
}, {
  value: '401',
  text: '401 - Temporary Work(Long-stay Activity) Visa'
}, {
  value: '402',
  text: '402 - Training and Research Visa'
}, {
  value: '403',
  text: '403 - Temporary Work (International Relations)'
}, {
  value: '407',
  text: '407 - Training'
}, {
  value: '408',
  text: '408 - Temporary Activity'
}, {
  value: '415',
  text: '415 - Foreign Government Agency'
}, {
  value: '416',
  text: '416 - Special Program Visa'
}, {
  value: '417',
  text: '417 - Working Holiday'
}, {
  value: '418',
  text: '418 - Educational'
}, {
  value: '420',
  text: '420 - Entertainment Visa/Temporary Work (Entertainment)'
}, {
  value: '421',
  text: '421 - Sport'
}, {
  value: '422',
  text: '422 - Medical Practitioner (Temporary)'
}, {
  value: '428',
  text: '428 - Religious Worker'
}, {
  value: '442',
  text: '442 - Occupational Trainee Visa'
}, {
  value: '444',
  text: '444 - Special Category'
}, {
  value: '445',
  text: '445 - Dependant Child'
}, {
  value: '451',
  text: '451 - Secondary Movement Relocation (Temporary)'
}, {
  value: '457',
  text: '457 - Temporary Work (Skilled) Visa'
}, {
  value: '461',
  text: '461 - New Zealand Citizen Family Relationship (Temporary)'
}, {
  value: '462',
  text: '462 - Work and Holiday'
}, {
  value: '471',
  text: '471 - Trade Skills Training'
}, {
  value: '475',
  text: '475 - Skilled'
}, {
  value: '476',
  text: '476 - Skilled'
}, {
  value: '482',
  text: '482 - Temporary Skill Shortage (TSS) Visa'
}, {
  value: '485',
  text: '485 - Temporary Graduate'
}, {
  value: '487',
  text: '487 - Skilled'
}, {
  value: '488',
  text: '488 - Superyacht Crew'
}, {
  value: '489',
  text: '489 - Skilled - Nominated or Sponsored (Provisional)'
}, {
  value: '496',
  text: '496 - Skilled'
}, {
  value: '580',
  text: '580 - Student Guardian'
}, {
  value: '590',
  text: '590 - Student Guardian'
}, {
  value: '600',
  text: '600 - Visitor Visa'
}, {
  value: '601',
  text: '601 - Electronic Travel Authority'
}, {
  value: '651',
  text: '651 - eVisitor'
}, {
  value: '676',
  text: '676 - Tourist'
}, {
  value: '820',
  text: '820 - Partner temporary'
}, {
  value: '956',
  text: '956 - ETA (Business Entrant - Long Validity)'
}, {
  value: '976',
  text: '976 - ETA (Visitor)'
}, {
  value: '977',
  text: '977 - ETA (Business Entrant - Short Validity)'
}, {
  value: '988',
  text: '988 - Maritime Crew'
}, {
  value: '995',
  text: '995 - Diplomatic (Temporary)'
}];